export default __webpack_public_path__ + "static/media/welcome-illustration.42a1f8c9.svg";